<div class="multipoint-type-charge">
  <div class="multipoint-type-charge__header">
    <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.TITLE' | i18nextEager }}</h2>
  </div>
  <section class="multipoint-type-charge__section-min">
    <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.INFO' | i18nextEager }}</h2>
    <form [formGroup]="typeChargeForm">
      <mat-radio-group formControlName="chargeManual" class="multipoint-type-charge__container-center">
        <mat-radio-button [value]="true">
          <span class="multipoint-type-charge__label-radio">
            {{ 'NEW_CONTRACTS.INSTALLATION_DATA.CHARGE_MANUAL' | i18nextEager }}
          </span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span class="multipoint-type-charge__label-radio">
            {{ 'NEW_CONTRACTS.INSTALLATION_DATA.CHARGE_FILE' | i18nextEager }}
          </span>
        </mat-radio-button>
      </mat-radio-group>
      <div *ngIf="typeChargeForm.get('chargeManual').value === false" class="multipoint-type-charge__container-center">
        <div class="multipoint-type-charge__container-icons">
          <img
            (click)="handleDownload()"
            src="/assets/icons/download.svg"
            class="cursor-pointer"
            alt="{{ 'NEW_CONTRACTS.INSTALLATION_DATA.DOWNLOAD_TEMPLATE' | i18nextEager }}"
          />
          <span>
            {{ 'NEW_CONTRACTS.INSTALLATION_DATA.DOWNLOAD_TEMPLATE' | i18nextEager }}
          </span>
        </div>
        <div class="multipoint-type-charge__container-icons">
          <input type="file" hidden="true" #inputFile (change)="handleCharge($event.target.files[0])" accept=".xlsx" />
          <img
            (click)="input.nativeElement.click()"
            src="/assets/icons/upload.svg"
            class="cursor-pointer"
            alt="{{ 'NEW_CONTRACTS.INSTALLATION_DATA.LOAD_DATA' | i18nextEager }}"
          />
          <span>
            {{ 'NEW_CONTRACTS.INSTALLATION_DATA.LOAD_DATA' | i18nextEager }}
          </span>
        </div>
      </div>
    </form>
  </section>
  <ng-container *ngIf="typeChargeForm.get('chargeManual').value">
    <section>
      <h2>{{ 'NEW_CONTRACTS.NOTIFICATION_ADDRESS' | i18nextEager }}</h2>
      <form [formGroup]="typeChargeForm">
        <mat-radio-group formControlName="allAddressNotification" class="multipoint-type-charge__container-center">
          <mat-radio-button [value]="true">
            <span class="multipoint-type-charge__label-radio">
              {{ 'NEW_CONTRACTS.INSTALLATION_DATA.ALL_SAME' | i18nextEager }}
            </span>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <span class="multipoint-type-charge__label-radio">
              {{ 'NEW_CONTRACTS.INSTALLATION_DATA.NOT_SAME' | i18nextEager }}
            </span>
          </mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="typeChargeForm.get('allAddressNotification').value">
          <app-custom-select
            class="custom-select"
            [label]="'NEW_CONTRACTS.ROAD_TYPE'"
            [controlName]="'addressNotifRoadType'"
            [values]="roadTypesList"
            [defaultValue]="typeChargeForm.get('addressNotifRoadType').value"
            [searchBar]="true"
            [disabled]="typeChargeForm.get('addressNotifRoadType').disabled"
          ></app-custom-select>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</mat-label>
            <input matInput formControlName="addressNotifName" maxlength="100" />
          </mat-form-field>
          <div class="tree-col">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
                <input matInput formControlName="addressNotifNumber" maxlength="8" alphanumeric />
                <mat-error
                  *ngIf="
                    typeChargeForm?.get('addressNotifNumber').errors?.maxlength &&
                    (typeChargeForm?.get('addressNotifNumber').touched || typeChargeForm?.get('addressNotifNumber').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !typeChargeForm?.get('addressNotifNumber').errors?.maxlength &&
                    typeChargeForm?.get('addressNotifNumber').errors?.invalidInitialValue &&
                    (typeChargeForm?.get('addressNotifNumber').touched || typeChargeForm?.get('addressNotifNumber').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</mat-label>
                <input matInput formControlName="addressNotifGate" maxlength="10" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</mat-label>
                <input matInput formControlName="addressNotifStair" maxlength="3" alphanumeric />
                <mat-error
                  *ngIf="
                    typeChargeForm?.get('addressNotifStair').errors?.maxlength &&
                    (typeChargeForm?.get('addressNotifStair').touched || typeChargeForm?.get('addressNotifStair').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !typeChargeForm?.get('addressNotifStair').errors?.maxlength &&
                    typeChargeForm?.get('addressNotifStair').errors?.invalidInitialValue &&
                    (typeChargeForm?.get('addressNotifStair').touched || typeChargeForm?.get('addressNotifStair').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="tree-col">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
                <input matInput formControlName="addressNotifFloor" maxlength="3" alphanumeric />
                <mat-error
                  *ngIf="
                    typeChargeForm?.get('addressNotifFloor').errors?.maxlength &&
                    (typeChargeForm?.get('addressNotifFloor').touched || typeChargeForm?.get('addressNotifFloor').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !typeChargeForm?.get('addressNotifFloor').errors?.maxlength &&
                    typeChargeForm?.get('addressNotifFloor').errors?.invalidInitialValue &&
                    (typeChargeForm?.get('addressNotifFloor').touched || typeChargeForm?.get('addressNotifFloor').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</mat-label>
                <input matInput formControlName="addressNotifDoor" maxlength="3" alphanumeric />
                <mat-error
                  *ngIf="
                    typeChargeForm?.get('addressNotifDoor').errors?.maxlength &&
                    (typeChargeForm?.get('addressNotifDoor').touched || typeChargeForm?.get('addressNotifDoor').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !typeChargeForm?.get('addressNotifDoor').errors?.maxlength &&
                    typeChargeForm?.get('addressNotifDoor').errors?.invalidInitialValue &&
                    (typeChargeForm?.get('addressNotifDoor').touched || typeChargeForm?.get('addressNotifDoor').dirty)
                  "
                >
                  {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field *ngIf="isUserSpanish" appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                <input matInput formControlName="addressNotifPostalCode" maxlength="5" />
              </mat-form-field>
              <div *ngIf="!isUserSpanish">
                <div class="multipoint-type-charge__pt-postal-code-field">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                    <input matInput formControlName="addressNotifPostalCodePT1" maxlength="4" />
                  </mat-form-field>
                  <p class="multipoint-type-charge__postal-code-hyphen">
                    {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
                  </p>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="addressNotifPostalCodePT2" maxlength="3" />
                  </mat-form-field>
                </div>
                <mat-error
                  *ngIf="
                    (
                      typeChargeForm?.controls.addressNotifPostalCodePT1.errors?.required ||
                      typeChargeForm?.controls.addressNotifPostalCodePT2.errors?.required
                    ) &&
                    (
                      typeChargeForm.controls.addressNotifPostalCodePT1.touched ||
                      typeChargeForm.controls.addressNotifPostalCodePT1.dirty ||
                      typeChargeForm.controls.addressNotifPostalCodePT2.touched ||
                      typeChargeForm.controls.addressNotifPostalCodePT2.dirty
                    )
                  "
                  class="multipoint-type-charge__pt-postal-code-error"
                >
                  {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
                </mat-error>
                <mat-error
                  *ngIf="
                    !typeChargeForm?.controls.addressNotifPostalCodePT1.errors?.required &&
                    !typeChargeForm?.controls.addressNotifPostalCodePT2.errors?.required &&
                    typeChargeForm?.controls.addressNotifPostalCode.errors?.pattern &&
                    (
                      typeChargeForm.controls.addressNotifPostalCodePT1.touched ||
                      typeChargeForm.controls.addressNotifPostalCodePT1.dirty ||
                      typeChargeForm.controls.addressNotifPostalCodePT2.touched ||
                      typeChargeForm.controls.addressNotifPostalCodePT2.dirty
                    )
                  "
                  class="multipoint-type-charge__pt-postal-code-error"
                >
                  {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
                </mat-error>
              </div>
            </div>
          </div>
          <ng-container *ngIf="townNotificationList.length <= 1; else selectTemplateAddressNotifTown">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</mat-label>
              <input matInput formControlName="addressNotifTown" maxlength="100" />
            </mat-form-field>
          </ng-container>
          <ng-template #selectTemplateAddressNotifTown>
            <app-custom-select
              class="custom-select"
              [label]="'NEW_CONTRACTS.TOWN'"
              [controlName]="'addressNotifTown'"
              [values]="townNotificationList"
              [defaultValue]="typeChargeForm.get('addressNotifTown').value"
              [disabled]="typeChargeForm.get('addressNotifTown').disabled"
            >
            </app-custom-select>
          </ng-template>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</mat-label>
            <input
              matInput
              formControlName="addressNotifProvince"
              maxlength="100"
              placeholder="{{ 'NEW_CONTRACTS.PROVINCE_EXAMPLE' | i18nextEager }}"
            />
          </mat-form-field>
        </ng-container>
      </form>
    </section>
    <section>
      <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.CONTACT_PERSON' | i18nextEager }}</h2>
      <form [formGroup]="typeChargeForm">
        <mat-radio-group formControlName="allContactPerson" class="multipoint-type-charge__container-center">
          <mat-radio-button [value]="true">
            <span class="multipoint-type-charge__label-radio">
              {{ 'NEW_CONTRACTS.INSTALLATION_DATA.ALL_SAME' | i18nextEager }}
            </span>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <span class="multipoint-type-charge__label-radio">
              {{ 'NEW_CONTRACTS.INSTALLATION_DATA.NOT_SAME' | i18nextEager }}
            </span>
          </mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="typeChargeForm.get('allContactPerson').value">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</mat-label>
            <input matInput formControlName="contactName" maxlength="50" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</mat-label>
            <input matInput formControlName="contactSurname" maxlength="50" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.DNI_NIE' | i18nextEager }} </mat-label>
            <input
              matInput
              formControlName="contactDocumentNumber"
              maxlength="9"
              placeholder="{{ isUserSpanish ? ('NEW_CONTRACTS.DNI_EXAMPLE' | i18nextEager) : '' }}"
            />
            <mat-error
              *ngIf="
                typeChargeForm?.controls.contactDocumentNumber.errors?.invalid_dni
                || typeChargeForm?.controls.contactDocumentNumber.errors?.invalid_cif
              "
            >
              {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.EMAIL' | i18nextEager }} </mat-label>
            <input
              matInput
              formControlName="contactEmail"
              placeholder="{{ 'NEW_CONTRACTS.EMAIL_EXAMPLE' | i18nextEager }}"
              maxlength="50"
            />
            <mat-error
              *ngIf="
                typeChargeForm?.controls.contactEmail.errors &&
                typeChargeForm?.controls.contactEmail.value &&
                (typeChargeForm.controls.contactEmail.touched || typeChargeForm.controls.contactEmail.dirty)
              "
            >
              {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <div class="multipoint-type-charge__mobile-field">
            <div *ngIf="!isUserSpanish" class="multipoint-type-charge__country-code">
              <app-custom-select
                [required]="true"
                [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
                [controlName]="'contactMobileCountryCode'"
                [values]="contactMobileCountryCodeList"
                [disabled]="typeChargeForm.get('contactMobileCountryCode').disabled"
                [defaultValue]="typeChargeForm.get('contactMobileCountryCode').value"
              ></app-custom-select>
            </div>
            <div class="multipoint-type-charge__mobile-input">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }} </mat-label>
                <input matInput formControlName="contactMobile" maxlength="9" numeric />
                <mat-error
                  *ngIf="
                    typeChargeForm?.controls.contactMobile.errors?.invalid_mobile &&
                    typeChargeForm?.controls.contactMobile.value
                  "
                >
                  {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </ng-container>
      </form>
    </section>
    <section *ngIf="isUserSpanish">
      <h2>{{ 'NEW_CONTRACTS.BANK_ACCOUNT' | i18nextEager }}</h2>
      <form [formGroup]="typeChargeForm">
        <mat-radio-group formControlName="allAccountBank" class="multipoint-type-charge__container-center">
          <mat-radio-button [value]="true">
            <span class="multipoint-type-charge__label-radio">
              {{ 'NEW_CONTRACTS.INSTALLATION_DATA.ALL_SAME' | i18nextEager }}
            </span>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <span class="multipoint-type-charge__label-radio">
              {{ 'NEW_CONTRACTS.INSTALLATION_DATA.NOT_SAME' | i18nextEager }}
            </span>
          </mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="typeChargeForm.get('allAccountBank').value">
          <div class="multipoint-type-charge__account">
            <mat-form-field appearance="outline" id="ibanCode">
              <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
              <input
                matInput
                uppercase
                id="ibanInput"
                formControlName="ibanCode"
                maxlength="4"
                (paste)="onPasteIBAN($event)"
                (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput')"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" id="ibanEntity">
              <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
              <input
                matInput
                numeric
                id="entityInput"
                formControlName="ibanEntity"
                maxlength="4"
                (paste)="onPasteIBAN($event)"
                (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput')"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" id="ibanOffice">
              <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
              <input
                matInput
                numeric
                id="officeInput"
                formControlName="ibanOffice"
                maxlength="4"
                (paste)="onPasteIBAN($event)"
                (keyup)="bankAccountKeyUp($event, 'entityInput', 'officeInput', isUserSpanish ? 'dcInput' : 'accountInput')"
              />
            </mat-form-field>
            <mat-form-field *ngIf="isUserSpanish" appearance="outline" id="ibanDC">
              <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
              <input
                matInput
                numeric
                id="dcInput"
                formControlName="ibanDC"
                maxlength="2"
                (paste)="onPasteIBAN($event)"
                (keyup)="bankAccountKeyUp($event, 'officeInput', 'dcInput', 'accountInput')"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" id="ibanAccount">
              <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
              <input
                matInput
                numeric
                id="accountInput"
                formControlName="ibanAccount"
                [maxlength]="isUserSpanish ? 10 : 11"
                (paste)="onPasteIBAN($event)"
                (keyup)="
                  bankAccountKeyUp(
                    $event,
                    isUserSpanish ? 'dcInput' : 'officeInput',
                    'accountInput',
                    isUserSpanish ? null : 'dcInput'
                  )
                "
              />
            </mat-form-field>
            <mat-form-field *ngIf="!isUserSpanish" appearance="outline" id="ibanDC">
              <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
              <input
                matInput
                numeric
                id="dcInput"
                formControlName="ibanDC"
                maxlength="2"
                (paste)="onPasteIBAN($event)"
                (keyup)="bankAccountKeyUp($event, 'accountInput', 'dcInput', null)"
              />
            </mat-form-field>
          </div>
          <mat-error class="multipoint-type-charge__account-error" *ngIf="typeChargeForm?.hasError('invalid_IBAN')">
            {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
          </mat-error>
        </ng-container>
      </form>
    </section>
  </ng-container>
</div>
